var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 20.8151L15.7455 15.6231C16.9932 14.1252 17.6154 12.204 17.4826 10.2591C17.3499 8.31424 16.4724 6.4954 15.0328 5.18099C13.5931 3.86658 11.7022 3.15779 9.75325 3.20207C7.80434 3.24635 5.94752 4.0403 4.56908 5.41874C3.19063 6.79719 2.39669 8.654 2.3524 10.6029C2.30812 12.5518 3.01691 14.4428 4.33132 15.8824C5.64574 17.3221 7.46457 18.1995 9.40947 18.3323C11.3544 18.465 13.2756 17.8429 14.7734 16.5952L19.9654 21.7872L20.9375 20.8151ZM3.75003 10.7872C3.75003 9.56343 4.11292 8.36714 4.79281 7.34961C5.4727 6.33208 6.43906 5.53901 7.56968 5.07069C8.7003 4.60238 9.94439 4.47984 11.1447 4.71859C12.3449 4.95734 13.4474 5.54664 14.3128 6.41197C15.1781 7.27731 15.7674 8.37982 16.0061 9.58008C16.2449 10.7803 16.1224 12.0244 15.654 13.1551C15.1857 14.2857 14.3927 15.252 13.3751 15.9319C12.3576 16.6118 11.1613 16.9747 9.93753 16.9747C8.29706 16.9729 6.72431 16.3204 5.56432 15.1604C4.40433 14.0004 3.75185 12.4277 3.75003 10.7872V10.7872Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b7d2ede5b165d7513f1b941c15409ccf.svg";
export { ForwardRef as ReactComponent };